import React from "react";
import PropTypes from "prop-types";
import parse from "html-react-parser";
import { useIntl } from "react-intl";

export function TextCellAligned(props) {
  let formattedContent;

  try {
    const intl = useIntl();
    formattedContent = intl.formatMessage({
      id: props.text,
      defaultMessage: props.text,
      description: "",
    });
  } catch (error) {
    formattedContent = parse(props.text);
  }

  return (
    <td className={props.className} colspan={props.colspan}>
      <div className={`dataTable_row_textAligned_contents`}>
        <p>{formattedContent}</p>
      </div>
    </td>
  );
}

TextCellAligned.propTypes = {
  /**
   * Text to be displayed on the cell
   */
  text: PropTypes.string,
  /**
   * className to be set on the cell
   */
  className: PropTypes.string,
};
